import React from 'react';
import {colors} from 'styles/shared';

function Icon(props) {
  let color = props.disabled ? colors.darkBlue_lighter : colors.yellow_lighter;

  let backgroundColor = props.disabled ? colors.darkBlue_light : '#FFC361';

  return (
    <svg width="70" height="70" fill="none" viewBox="0 0 70 70">
      <rect width="70" height="70" fill={color} rx="35"></rect>
      <path
        fill={backgroundColor}
        fillRule="evenodd"
        d="M50.375 28.875h7.188A1.436 1.436 0 0159 30.313v11.5a1.438 1.438 0 01-1.438 1.437h-7.187v1.438a1.438 1.438 0 01-1.438 1.437H23.064a1.436 1.436 0 01-1.438-1.438V43.25h-7.188A1.436 1.436 0 0113 41.812v-11.5a1.419 1.419 0 01.421-1.016c.27-.27.635-.421 1.017-.421h7.187v-1.438A1.438 1.438 0 0123.063 26h25.875a1.436 1.436 0 011.437 1.438v1.437zm-34.5 2.875v8.625h5.75V31.75h-5.75zm8.625 11.5h23V28.875h-23V43.25zm25.875-2.875h5.75V31.75h-5.75v8.625zm-21.563-5.75h14.375a1.436 1.436 0 100-2.875H28.813a1.436 1.436 0 100 2.875zm0 5.75h14.375a1.436 1.436 0 100-2.875H28.813a1.436 1.436 0 100 2.875z"
        clipRule="evenodd"></path>
    </svg>
  );
}

export default Icon;
